import CommonApi from '../commonApi';
import { fetchRequest } from './index';
const pddTest = new CommonApi('pddTest', 'Тесты ПДД');
export const generateExam = async () => {
  const data = await fetchRequest.get(`/pddTest/generateExam`);
  if (data) return data;
  throw new Error('Не удалось получить вопросы для экзамена!');
};
export default {
  ...pddTest,
  generateExam
};
